import axios from "axios";

const fileMTModule = {
    namespaced: true,
    state: {
      filesMzData: {},
      shownMzDialog: false
    },
    getters: {
      getFilesMzData(state) {
        return state.filesMzData;
      },
      isShownMzDialog(state) {
        return state.shownMzDialog;
      },
      hasAnyFileMzGrant(state) {
        return state.filesMzData.length && 
          state.filesMzData.filter((f) => f.has_mz_cell || f.has_mz_semen).length !== 0 ? true : false
      },
      getFileMzGrantByMaterialType: (state) => (materialType) => {
        let fileMzFound = [];
        if (state.filesMzData.length) {
          if (materialType === 'mtCell') {
            fileMzFound = state.filesMzData.filter((f) => f.has_mz_cell).sort(
              (a, b) => (new Date(b.mz_cell_expiration_date)) - (new Date(a.mz_cell_expiration_date))
            ).map(e => ({
              ...e, 
              treatment_location_code: e.mz_cell_treatment_location_code,
              treatment_location_name: e.mz_cell_treatment_location_name
            }));
          } else if (materialType === 'mtSemen') {
            fileMzFound = state.filesMzData.filter((f) => f.has_mz_semen).sort(
              (a, b) => (new Date(b.mz_semen_expiration_date)) - (new Date(a.mz_semen_expiration_date))
            ).map(e => ({
              ...e, 
              treatment_location_code: e.mz_semen_treatment_location_code,
              treatment_location_name: e.mz_semen_treatment_location_name
            }));
          }
        }
        return fileMzFound.length ? fileMzFound[0] : null;
      }
    },
    actions: {
      fetchFiles({commit, dispatch}) {
        axios.get('/api/person/file/mt')
          .then((response) => {
            dispatch('clearFilesMzData');
            dispatch('clearShownMzDialog');
            commit('setFilesMzData', response.data.files_data.map(e => ({
                file_id: e.file_id,
                has_mz_cell: e.has_mz_cell,
                has_mz_semen: e.has_mz_semen,
                mz_cell_expiration_date: e.mz_cell_expiration_date,
                mz_semen_expiration_date: e.mz_semen_expiration_date,
                mz_cell_treatment_location_code: e.mz_cell_treatment_location_code,
                mz_cell_treatment_location_name: e.mz_cell_treatment_location_name,
                mz_semen_treatment_location_code: e.mz_semen_treatment_location_code,
                mz_semen_treatment_location_name: e.mz_semen_treatment_location_name,
              })
            ));
          });
      },
      setFilesMzData({commit}, filesMzData) {
        commit('setFilesMzData', filesMzData);
      },
      setShownMzDialog({commit}, shownMzDialog) {
        commit('setShownMzDialog', shownMzDialog);
      },
      clearFilesMzData({commit}) {
        commit('setFilesMzData', {});
      },
      clearShownMzDialog({commit}) {
        commit('setShownMzDialog', false);
      },
      clearState({commit}) {
        commit('setFilesMzData', {});
        commit('setShownMzDialog', false);
      }
    },
    mutations: {
      setFilesMzData(state, filesMzData) {
        state.filesMzData = filesMzData;
      },
      setShownMzDialog(state, shownMzDialog) {
        state.shownMzDialog = shownMzDialog;
      }
    }
  }

  export default fileMTModule;